import { styled, Alert } from '@mui/material';

const StyledAlert = styled(Alert)(({ theme }) => ({
  margin: theme.spacing(1, 4, 1, 0)
}));

export default StyledAlert;
